import { getGoogleSettings } from 'services/authorization/authorization.service';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { IGoogleSettings } from 'services/authorization/types';

export const ThunkGetGoogleSettings = createAsyncThunk<IGoogleSettings>(
  'authorization/getGoogleSettings',
  () => getGoogleSettings().then(res => res.data),
);
